/* @flow */
import appActions from './app';
import authActions from './auth';
import newsActions from './news';
import featuredActions from './featured';
import featuredMediaActions from './featuredMedia';
import categoriesActions from './categories';
import worklistsActions from './worklists';
import usagesActions from './usages';
import productionsActions from './productions';
import playerQueueAction from './playerQueue';
import trackSearchAction from './trackSearch';
import mediaSearchAction from './mediaSearch';
import mediaAction from './media';
import cartActions from './cart';
import smartlistsActions from './smartlists';
import smartlistActions from './smartlist';
import onDemandActions from './onDemand';

export default {
  ...appActions,
  ...authActions,
  ...newsActions,
  ...featuredActions,
  ...featuredMediaActions,
  ...categoriesActions,
  ...worklistsActions,
  ...usagesActions,
  ...trackSearchAction,
  ...mediaSearchAction,
  ...mediaAction,
  ...productionsActions,
  ...playerQueueAction,
  ...cartActions,
  ...smartlistsActions,
  ...smartlistActions,
  ...onDemandActions,
};
